import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { Tab, Tabs, Box } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import PATHS from 'constants/paths';

const LinkTab = (props) => {
  return <Tab component={Link} color="primary" {...props} />;
};

const ComplaintTabs = ({ tab, showHostTab }) => {
  return (
    <Box boxShadow={3}>
      <Tabs value={tab} indicatorColor="primary" textColor="primary" centered>
        <LinkTab
          label={<FormattedMessage id="complaints.tabs.my" defaultMessage="My Complaints" />}
          to={PATHS.complaints.root}
        />
        {showHostTab && (
          <LinkTab
            label={
              <FormattedMessage
                id="complaints.tabs.fromGuests"
                defaultMessage="Complaints from Guests"
              />
            }
            to={PATHS.hostComplaints.root}
          />
        )}
      </Tabs>
    </Box>
  );
};

ComplaintTabs.propTypes = {
  tab: PropTypes.number.isRequired,
  showHostTab: PropTypes.bool,
};

ComplaintTabs.defaultProps = {
  showHostTab: false,
};

export default ComplaintTabs;
